export enum ExternalCtrlMessageKey {
  $error = '$error'
}
